export const faqInfo = [
    {
        title: 'Что такое токены?',
        text: 'Токен — это виртуальная валюта AIR, которую пользователи тратят на генерации. Их цена зависит от длины запроса, настроек нейросети и типа контента. Например, текст в ChatGPT будет стоить примерно 1 токен, а картинка в Flux — 3 токена.\n',
    },
    {
        title: 'Где проверять баланс токенов? Как следить за расходами?\n',
        text: 'Траты по всем категориям и текущий баланс можно проверять в разделе «‎Дашборд».',
    },
]

